$(document).ready(function() {

    if ($('body#authentication').length > 0) {
        if ($('#main-register-form input[name="email"]').length > 0) {
            $('#main-register-form input[name="email"]').prop('readonly', true);
        }
    }

    $('#precreate-account').on('submit', function(e) {
        e.preventDefault();
        e.stopPropagation();

        var $form = $(this);

        $.ajax({
            type: 'POST',
            data: $form.serialize(),
            dataType: 'json'
        }).done(function(data) {

            $('#precreate-errors').html('');
            console.log(data);
            if (data.success) {
                
                $('#register-ajax').html(data.html);

                if ($('#register-ajax input[name="email"]').length > 0) {
                    $('#register-ajax input[name="email"]').prop('readonly', true)
                }

                $('#main-user-form').fadeOut(300);
                setTimeout(function() {
                    $('#register-ajax').fadeIn(300);
                }, 300);
                
                $('#precreate-errors').hide();
            } else {
                if (data.errors) {
                    data.errors.forEach(function(error) {
                        $('#precreate-errors').append('<li>' + error + '</li>');
                    });
                    $('#precreate-errors').show();
                }
            }

        }).fail(function(data) {
            console.log(data);
        });
      


        return false;
    });
});